
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "BaseModalLayout1402610464",
      {"classes":{"root":"BaseModalLayout1402610464__root","controlButtons":"BaseModalLayout1402610464__controlButtons","helpButton":"BaseModalLayout1402610464__helpButton","closeButton":"BaseModalLayout1402610464__closeButton","helpIcon":"BaseModalLayout1402610464__helpIcon","header":"BaseModalLayout1402610464__header","content":"BaseModalLayout1402610464__content","footer":"BaseModalLayout1402610464__footer","footnote":"BaseModalLayout1402610464__footnote","illustration":"BaseModalLayout1402610464__illustration"},"vars":{},"stVars":{"modalBoxPadding":"48px","helpIconSize":"24px"},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  